(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-hero-inicio"] && !Shopify.designMode) return;
  try {
    
  /* Carrusel del hero de inicio: fundido automático, puntos, pausa y deslizar con el dedo */
  if (!customElements.get('rf-hero-carrusel')) {
    class RfHeroCarrusel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (this.slides.length < 2) return;

        this.puntos = Array.from(this.querySelectorAll('[data-punto]'));
        this.botonPausa = this.querySelector('[data-pausa]');
        this.actual = 0;
        this.ms = parseInt(this.dataset.intervalo, 10) || 6000;
        this.pausadoPorUsuario = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pausaTemporal = false;

        this.puntos.forEach((p, i) => p.addEventListener('click', () => { this.ir(i); this.reiniciar(); }));
        this.botonPausa.addEventListener('click', () => {
          this.pausadoPorUsuario = !this.pausadoPorUsuario;
          this.actualizarPausa();
          this.reiniciar();
        });

        /* Se detiene mientras el mouse o el foco del teclado están sobre el hero */
        const hero = this.closest('.rf-hero') || this;
        hero.addEventListener('mouseenter', () => { this.pausaTemporal = true; this.detener(); });
        hero.addEventListener('mouseleave', () => { this.pausaTemporal = false; this.reiniciar(); });
        hero.addEventListener('focusin', () => { this.pausaTemporal = true; this.detener(); });
        hero.addEventListener('focusout', () => { this.pausaTemporal = false; this.reiniciar(); });

        /* Deslizar con el dedo en móvil */
        let inicioX = null;
        hero.addEventListener('touchstart', (e) => { inicioX = e.touches[0].clientX; }, { passive: true });
        hero.addEventListener('touchend', (e) => {
          if (inicioX === null) return;
          const dx = e.changedTouches[0].clientX - inicioX;
          if (Math.abs(dx) > 40) { this.ir(this.actual + (dx < 0 ? 1 : -1)); this.reiniciar(); }
          inicioX = null;
        });

        /* Sin avanzar cuando la pestaña no está visible */
        this.alCambiarVisibilidad = () => (document.hidden ? this.detener() : this.reiniciar());
        document.addEventListener('visibilitychange', this.alCambiarVisibilidad);

        /* En el editor del tema: al seleccionar una diapositiva, se muestra y se detiene */
        this.alSeleccionar = (e) => {
          const i = this.slides.findIndex((s) => s.contains(e.target));
          if (i >= 0) { this.pausaTemporal = true; this.ir(i); this.detener(); }
        };
        this.alDeseleccionar = () => { this.pausaTemporal = false; this.reiniciar(); };
        document.addEventListener('shopify:block:select', this.alSeleccionar);
        document.addEventListener('shopify:block:deselect', this.alDeseleccionar);

        this.actualizarPausa();
        this.reiniciar();
      }

      disconnectedCallback() {
        this.detener();
        document.removeEventListener('visibilitychange', this.alCambiarVisibilidad);
        document.removeEventListener('shopify:block:select', this.alSeleccionar);
        document.removeEventListener('shopify:block:deselect', this.alDeseleccionar);
      }

      ir(i) {
        const total = this.slides.length;
        const destino = (i + total) % total;
        this.slides.forEach((s, j) => {
          const activa = j === destino;
          s.classList.toggle('is-activa', activa);
          if (activa) s.removeAttribute('aria-hidden');
          else s.setAttribute('aria-hidden', 'true');
        });
        this.puntos.forEach((p, j) => {
          if (j === destino) p.setAttribute('aria-current', 'true');
          else p.removeAttribute('aria-current');
        });
        this.actual = destino;
      }

      detener() {
        clearInterval(this.temporizador);
        this.temporizador = null;
      }

      reiniciar() {
        this.detener();
        if (this.pausadoPorUsuario || this.pausaTemporal || document.hidden) return;
        this.temporizador = setInterval(() => this.ir(this.actual + 1), this.ms);
      }

      actualizarPausa() {
        this.botonPausa.setAttribute('aria-label', this.pausadoPorUsuario ? 'Reanudar carrusel' : 'Pausar carrusel');
        this.botonPausa.classList.toggle('is-pausado', this.pausadoPorUsuario);
      }
    }
    customElements.define('rf-hero-carrusel', RfHeroCarrusel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-producto-encabezado"] && !Shopify.designMode) return;
  try {
    
  /* Galería del encabezado de producto: flechas y puntos. El deslizamiento lo hace el navegador (scroll-snap). */
  if (!customElements.get('rf-galeria')) {
    class RfGaleria extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-controles')) return;
        this.pista = this.querySelector('[data-pista]');
        this.slides = Array.from(this.pista.children);
        this.puntos = Array.from(this.querySelectorAll('[data-punto]'));
        this.actual = 0;

        this.querySelector('[data-anterior]').addEventListener('click', () => this.ir(this.actual - 1));
        this.querySelector('[data-siguiente]').addEventListener('click', () => this.ir(this.actual + 1));
        this.puntos.forEach((punto, i) => punto.addEventListener('click', () => this.ir(i)));

        /* Marca el punto de la imagen que está a la vista, también al deslizar con el dedo */
        this.observador = new IntersectionObserver(
          (entradas) => {
            entradas.forEach((e) => {
              if (e.isIntersecting) this.marcar(this.slides.indexOf(e.target));
            });
          },
          { root: this.pista, threshold: 0.6 }
        );
        this.slides.forEach((s) => this.observador.observe(s));
      }

      disconnectedCallback() {
        if (this.observador) this.observador.disconnect();
      }

      ir(i) {
        const total = this.slides.length;
        const destino = (i + total) % total;
        const suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pista.scrollTo({ left: destino * this.pista.clientWidth, behavior: suave ? 'smooth' : 'auto' });
        this.marcar(destino);
      }

      marcar(i) {
        if (i < 0) return;
        this.actual = i;
        this.puntos.forEach((p, j) => {
          if (j === i) p.setAttribute('aria-current', 'true');
          else p.removeAttribute('aria-current');
        });
      }
    }
    customElements.define('rf-galeria', RfGaleria);
  }

  } catch(e) { console.error(e); }
})();
})();
